import React from "react";
import * as Icons from "lucide-react";
import type { LucideProps } from "lucide-react";
import type { FC } from "react";

export type IconName = keyof typeof Icons;

export const renderLucideIcon = (name: IconName, props?: LucideProps): React.ReactNode => {
    const Icon = Icons[name] as FC<LucideProps> | undefined;

    if (!Icon) {
        return null;
    }

    return <Icon {...props} />;
};
